import { T4Summary } from '@app/models/payroll/t4-summary.model';
import { BadgeColumn } from '@app/modules/table/classes/badge-column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';
import { BadgeDisplay } from '@app/modules/table/interfaces/badge-display.interface';

export class NameColumn extends BadgeColumn<T4Summary> {
    title = 'table.employerPackage.name';
    property = 'name';
    sortField = 'name';
    sortable = true;
    type: CellDisplay = CellDisplay.string;

    getBadgeDisplay(t4Summary: T4Summary): BadgeDisplay | undefined {
        if (t4Summary.rptTcd !== 'A') {
            return {
                type: 'success',
                label: 'table.employerPackage.original',
            };
        }

        return {
            type: 'default',
            label: 'table.employerPackage.amendment',
        };
    }

    shouldShowBadge(): boolean {
        return true;
    }
}
